import {Box, Typography} from "@mui/material"
import LeftTabView from "../leftTab"
import HeaderView from "./header"

const styles = {
    root: {

    },
    contentsBox: {
        display: "flex",
        flexDirection: "row",
    }

}

const DocsView = () => {

    return (
        <Box style={styles.root}>
            <HeaderView />
            <Box style={styles.contentsBox}>
                <LeftTabView />
                <Box>
                    <Typography>実装中</Typography>
                </Box>
            </Box>
        </Box>
    )
}

export default DocsView
